import L from "leaflet";

/** Límites de navegación de un mapa: hasta dónde se puede alejar y hasta dónde
 *  se puede panear. */
export type LimitesDeMapa = {
  minZoom: number;
  /** Rectángulo para `setMaxBounds`. */
  panBounds: L.LatLngBounds;
};

/** Acota un mapa a lo que abarca **la pantalla un nivel de zoom más atrás** de
 *  donde entra `bounds`, y devuelve los límites aplicados.
 *
 *  **Por qué no se infla `bounds` con `pad()`.** Un `pad` es una fracción de la
 *  extensión del contenido, o sea que el margen se mide EN GRADOS y crece con
 *  el polígono: un predio chico queda con un margen minúsculo y uno grande con
 *  uno enorme, y al alejarse el margen se desvanece en pantalla. Derivar el
 *  rectángulo del VIEWPORT a `minZoom` deja el margen constante en píxeles a
 *  cualquier escala, que es lo que el usuario percibe.
 *
 *  El `-1` del zoom es ese "nivel de margen": el contenido entra completo y
 *  todavía sobra pantalla alrededor para que no se sienta encajonado.
 *
 *  **Ojo con el tamaño del contenedor:** `getBoundsZoom`/`getSize` leen el
 *  contenedor, así que si el layout cambió (un panel que se abre, un modal que
 *  se monta) hay que llamar a `invalidateSize()` ANTES — si no, Leaflet
 *  responde con el tamaño viejo y los límites salen corridos.
 *
 *  No mueve la vista: encuadrar (`fitBounds`) es decisión de quien llama.
 *  Devuelve `null` si `bounds` no es válido. */
export function fx_acotarMapaA(
  map: L.Map,
  bounds: L.LatLngBounds,
): LimitesDeMapa | null {
  if (!bounds.isValid()) return null;

  const minZoom = map.getBoundsZoom(bounds) - 1;
  const half = map.getSize().divideBy(2);
  const centro = map.project(bounds.getCenter(), minZoom);
  const panBounds = L.latLngBounds(
    map.unproject(centro.subtract(half), minZoom),
    map.unproject(centro.add(half), minZoom),
  );

  map.setMinZoom(minZoom);
  map.setMaxBounds(panBounds);

  return { minZoom, panBounds };
}
